exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-group[data-v-4d426429] {\n    position: relative;\n}\n.form-group button[data-v-4d426429] {\n    position: absolute;\n    right: 0;\n    top: -12px;\n    min-width: 30px;\n    width: 30px;\n    height: 30px;\n}\n.form-group .material-icons[data-v-4d426429] {\n    line-height: 30px;\n}\n#missions_list[data-v-4d426429] {\n    height: 200px;\n    overflow-y: scroll;\n}\n.mission[data-v-4d426429] {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.mission p[data-v-4d426429] {\n    margin: 0;\n}\n", ""]);

// exports
